/* eslint-disable arrow-body-style */
import Grid from '@mui/material/Grid';
import SideBarContainer from 'Containers/SideBarContainer';
import FilterContainer from 'Containers/FilterContainer';
import useTranslation from 'Hooks/useTranslation';
import Title from 'Components/Title';
import Search from 'Components/Search';
import Dropdown from 'Components/DropDown';
import BasicTable from 'Components/BasicTable';
import Toogle from 'Components/Toogle';
import CourseCard from 'Components/CourseCard';
import Alert from 'Components/Alert';
import { useLocation, useHistory } from 'react-router-dom';
import useFetch from './Hooks/useFetch';
import useComponent from './Hooks/useComponent';
import useEdit from './Hooks/useEdit';
import useModal from './Hooks/useModal';
import useComingFromPublish from './Hooks/useComingFromPublish';
import { useState } from 'react';
import { CoursesList, togleStyle, dropdownStyle, ContainerTable } from './style';

export default function MyCourses() {
  const comingFromPublish = useComingFromPublish();
  const location = useLocation();
  const isSuccesful = location?.state?.successful !== undefined;
  const [successful, setSuccessful] = useState(isSuccesful);
  const history = useHistory();
  const [courseEdited, setCourseEdited] = useState(comingFromPublish);
  const [isLoading, setIsLoading] = useState(true);

  if (comingFromPublish) {
    history.replace();
  }

  const [open, setOpen] = useState(comingFromPublish);
  const { t2 } = useTranslation('Courses');
  const {
    courses,
    setCourses,
    categories,
    setCategory,
    setName,
    setIscard,
    isCard,
    authors,
    setAuthor,
    setTerminal,
    terminals,
    setIsDraft,
    createCourse,
  } = useFetch(setIsLoading);

  const { thereIsComponent, colorCategory, sendToCourseDetails } = useComponent({
    courses,
    categories,
  });

  const { setOpenModal, AddCourseModal } = useModal();

  const { sendToEditCourse } = useEdit();

  const isDraftValues = {
    [t2('Active')]: false,
    [t2('Draft')]: true,
  };

  const changeIsDraft = key => {
    setIsDraft(isDraftValues[key] ?? '');
  };

  const handleCreateCourse = async course => {
    const newCourse = await createCourse(course);
    setSuccessful(true);
    setCourses([newCourse, ...courses]);
    setCourseEdited(false);
    setOpen(true);
  };

  const alertMsg = () => {
    if (!successful) {
      return t2('NotSuccessful');
    }

    return courseEdited ? t2('OnSuccessfullEdit') : t2('OnSuccessMessage');
  };

  return (
    <SideBarContainer>
      <Title
        title={t2('Title')}
        textButton={t2('AddCourse')}
        disabledButton={false}
        eventButton={() => setOpenModal(true)}
      />
      <FilterContainer>
        <Grid item xs={4} style={{ paddingLeft: '0' }}>
          <Search placeholder={t2('Search')} setData={setName} />
        </Grid>

        <Grid item xs={6} style={dropdownStyle}>
          <Dropdown title={t2('Status')} setData={changeIsDraft} options={Object.keys(isDraftValues)} />
          <Dropdown title={t2('Author')} setData={setAuthor} options={authors} />
          <Dropdown title={t2('Category')} setData={setCategory} options={categories} />
          <Dropdown title={t2('Terminal')} setData={setTerminal} options={terminals} />
        </Grid>
        <Grid item xs={2} md={2} style={togleStyle}>
          <Toogle value={isCard} onclick={setIscard} />
        </Grid>
      </FilterContainer>
      {isCard ? (
        <FilterContainer>
          <CoursesList>
            {courses.map((course, index) => (
              <CourseCard
                key={course[course.length - 1]}
                title={course[0]}
                description={course[1]}
                image={course[6] === '' ? null : course[6]}
                category={course[3]}
                userCreatedName={course[4]}
                userImage={course[5]}
                colorCategory={colorCategory[course[3]]}
                editEvent={() => {
                  sendToEditCourse(course);
                }}
                clickAction={() => sendToCourseDetails(course)}
                isDraft={!!course[8]}
              />
            ))}
          </CoursesList>
        </FilterContainer>
      ) : (
        <ContainerTable>
          <BasicTable
            information={courses}
            headers={[t2('TableTitle'), t2('Description'), t2('Priority'), t2('Category'), t2('CreatedBy')]}
            limit={5}
            thereIsComponent={thereIsComponent}
            widthColumn="25%"
            clickable
            clickAction={sendToCourseDetails}
            isLoading={isLoading}
          />
        </ContainerTable>
      )}
      <AddCourseModal acceptText={t2('CreateCourse')} onAccept={course => handleCreateCourse(course)} />
      <Alert message={alertMsg()} open={open} setOpen={setOpen} error={!successful} />
    </SideBarContainer>
  );
}
